export default "__VITE_ASSET__CVgKrowY__"